import { Navigate } from 'react-router-dom';

function BillingPage() {
  return <Navigate to="/apps/billing/plans" replace />;
}

export default BillingPage;
